import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-left-card',
  templateUrl: './left-card.component.html'
})
export class LeftCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
